import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export type ButtonColorVariant = 'primary' | 'secondary' | 'inverse';

export interface ButtonProps extends AntdButtonProps {
  loadingText?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  rounded?: boolean;
  colorVariant?: 'primary' | 'secondary' | 'inverse';
}

const getButtonStyle = (variant: ButtonColorVariant = 'primary') => {
  switch (variant) {
    case 'secondary':
      return {
        background: '#fff',
        color: '#1E6DF6',
        border: '1.5px solid #1E6DF6',
      };
    case 'inverse':
      return {
        background: '#1E6DF6',
        color: '#fff',
        border: '1.5px solid #1E6DF6',
      };
    default:
      return {};
  }
};

export const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  loadingText,
  icon,
  iconLeft,
  iconRight,
  style,
  rounded = false,
  colorVariant = 'primary',
  ...rest
}) => {
  return (
    <AntdButton
      loading={loading}
      icon={iconLeft || icon}
      style={{
        borderRadius: rounded ? 9999 : 7,
        fontWeight: 500,
        letterSpacing: 0.2,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        ...getButtonStyle(colorVariant),
        ...style,
      }}
      {...rest}
    >
      {loading && loadingText ? (
        <>
          <LoadingOutlined /> {loadingText}
        </>
      ) : (
        <>
          {children}
          {iconRight && <span style={{ marginLeft: 8 }}>{iconRight}</span>}
        </>
      )}
    </AntdButton>
  );
};
